import { clearAllLoaders } from '@/redux/slices/common';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
const RefundPolicy = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearAllLoaders());
  }, []);
  return <div className="terms-conditions" data-sentry-component="RefundPolicy" data-sentry-source-file="refundPolicy.jsx">
            <div className="container pt-2 pb-6">
                <div className="terms-conditions-wrapper">
                    <div className="terms-conditions-txt">
                        <h3>Payment and Refund Policy</h3>
                        <h4>Prices:</h4>
                        <p>
                            All the prices declared on the Website and Mobile App are inclusive of taxes. Please verify
                            the total payable amount during checkout before placing the order. Our prices are liable to
                            change anytime without notifying you. You shall be responsible for full payment of the order
                            received by you.
                        </p>
                        <p>
                            Chicking reserves the right to change its refund policies and payment terms at any time. For
                            refunds, customers must contact the Chicking call center within 7 days of purchase.
                            Customers may be required to provide supporting documents as requested by the Chicking team.
                            To initiate a refund, customers should contact Chicking via email at
                            contactus@chickinguae.com or by phone at 600 59 59 58.
                        </p>
                        <h4>Payment:</h4>
                        <p>
                            You are allowed to choose between various payments options while placing an order on the
                            Website and Mobile App. You agree to use your own debit/credit card or bank details for the
                            transaction. We would not be responsible for misuse of your card if all the security checks
                            are verified. You agree that the methods of payment may be updated from time to time on the
                            Website and Mobile App. You agree to review the same and use our website or Mobile App and
                            suitable payment option accordingly.
                        </p>
                        <h4>Complaints and Refund Policy:</h4>
                        <p>
                            You can contact us at the phone number provided to you while placing the specific order or
                            email us at with complete details of the complaint encountered by you. We shall try to fix
                            the issue amicably.
                        </p>
                        <p>Please find the below mentioned details.</p>
                        <p>
                            Email: <a href="mailto:contactus@chickinguae.com">contactus@chickinguae.com</a>
                            <br />
                            Telephone: 600 59 59 58
                            <br />
                            Web:{' '}
                            <a href="https://www.chickinguae.com" target="_blank" rel="noopener noreferrer">
                                https://www.chickinguae.com
                            </a>
                        </p>
                        <p>
                            Contact Address: <br></br>
                            #1106, ETA STAR, Al Manara Tower, PO Box: 87546,<br></br> Al Abraj Street, Business Bay,
                            Za&#39;abeel, Dubai, UAE.
                        </p>
                        <p>
                            After examining the complaint, we will immediately initiate refund to the Customer. You will
                            receive your refund within fourteen days from the date of complaint.
                        </p>
                    </div>
                </div>
            </div>
        </div>;
};
export default RefundPolicy;